// import { L12M, L30D, N30D } from '../../utils/constants/filterConstants';
// import { updateSeveralEntities } from '../../utils/reduxUtils';
import { IReduxAction } from '../../views/interfaces';
import { GET_PERFORMANCE_SUMMARY_SUCCESS } from '../actions';

const initialState = {
  data: null  
};

export const performanceSummaryReducer = (state = initialState, { type, payload }: IReduxAction) => {
  switch (type) {
    case GET_PERFORMANCE_SUMMARY_SUCCESS: {
      return { ...state, data: payload };
    }
    default:
      return state;
  }
}; 